import hi from '@/internationalization/trans/chefs/hi/hi.json';
export default {
  trans: hi,
};
